export const mockData = {
  country: 'united kingdom',
  language: 'en-GB',
  year: '2010',
  month: 'jan',
  day: '1',
  loginName: 'JONDOE12345',
  password: 'Test@123',
  rePassword: 'Test@123',
  displayName: 'JONDOE12345',
  email: 'email@gmail.com',
  parental_email: 'parental_email@gmail.com'
};

export const langOptions = [
  {
    value: 'af',
    label: 'Afrikaans'
  },
  {
    value: 'sq',
    label: 'Albanian'
  },
  {
    value: 'ar',
    label: 'Arabic'
  },
  {
    value: 'eu',
    label: 'Basque'
  },
  {
    value: 'be',
    label: 'Belarusian'
  },
  {
    value: 'bg',
    label: 'Bulgarian'
  },
  {
    value: 'ca',
    label: 'Catalan'
  },
  {
    value: 'hr',
    label: 'Croatian'
  },
  {
    value: 'zh',
    label: 'Chinese'
  },
  {
    value: 'cs',
    label: 'Czech'
  },
  {
    value: 'da',
    label: 'Danish'
  },
  {
    value: 'nl',
    label: 'Dutch'
  },
  {
    value: 'en',
    label: 'English'
  },
  {
    value: 'et',
    label: 'Estonian'
  },
  {
    value: 'fa',
    label: 'Farsi'
  },
  {
    value: 'fi',
    label: 'Finnish'
  },
  {
    value: 'fo',
    label: 'Faeroese'
  },
  {
    value: 'fr',
    label: 'French'
  },
  {
    value: 'gd',
    label: 'Gaelic'
  },
  {
    value: 'de',
    label: 'German'
  },
  {
    value: 'el',
    label: 'Greek'
  },
  {
    value: 'ga',
    label: 'Irish'
  },
  {
    value: 'he',
    label: 'Hebrew'
  },
  {
    value: 'hi',
    label: 'Hindi'
  },
  {
    value: 'hu',
    label: 'Hungarian'
  },
  {
    value: 'id',
    label: 'Indonesian'
  },
  {
    value: 'is',
    label: 'Icelandic'
  },
  {
    value: 'it',
    label: 'Italian (Standard)'
  },
  {
    value: 'ja',
    label: 'Japanese'
  },
  {
    value: 'ko',
    label: 'Korean'
  },
  {
    value: 'ku',
    label: 'Kurdish'
  },
  {
    value: 'lt',
    label: 'Lithuanian'
  },
  {
    value: 'lv',
    label: 'Latvian'
  },
  {
    value: 'mk',
    label: 'Macedonian (FYROM)'
  },
  {
    value: 'ml',
    label: 'Malayalam'
  },
  {
    value: 'ms',
    label: 'Malaysian'
  },
  {
    value: 'mt',
    label: 'Maltese'
  },
  {
    value: 'no',
    label: 'Norwegian'
  },
  {
    value: 'pa',
    label: 'Punjabi'
  },
  {
    value: 'pl',
    label: 'Polish'
  },
  {
    value: 'pt',
    label: 'Portuguese'
  },
  {
    value: 'rm',
    label: 'Rhaeto-Romanic'
  },
  {
    value: 'ro',
    label: 'Romanian'
  },
  {
    value: 'ru',
    label: 'Russian'
  },
  {
    value: 'sb',
    label: 'Sorbian'
  },
  {
    value: 'sk',
    label: 'Slovak'
  },
  {
    value: 'sl',
    label: 'Slovenian'
  },
  {
    value: 'sr',
    label: 'Serbian'
  },
  {
    value: 'es',
    label: 'Spanish'
  },
  {
    value: 'sv',
    label: 'Swedish'
  },
  {
    value: 'th',
    label: 'Thai'
  },
  {
    value: 'tn',
    label: 'Tswana'
  },
  {
    value: 'tr',
    label: 'Turkish'
  },
  {
    value: 'ts',
    label: 'Tsonga'
  },
  {
    value: 'ua',
    label: 'Ukrainian'
  },
  {
    value: 'ur',
    label: 'Urdu'
  },
  {
    value: 've',
    label: 'Venda'
  },
  {
    value: 'vi',
    label: 'Vietnamese'
  },
  {
    value: 'cy',
    label: 'Welsh'
  },
  {
    value: 'xh',
    label: 'Xhosa'
  },
  {
    value: 'ji',
    label: 'Yiddish'
  },
  {
    value: 'zu',
    label: 'Zulu'
  }
];

export const countryOptions = [
  { label: 'United Kingdom', value: 'GB' },
  { label: 'United States of America', value: 'US' },
  { label: 'Canada', value: 'CA' },
  { label: 'Albania', value: 'AL' },
  { label: 'Algeria', value: 'DZ' },
  { label: 'American Samoa', value: 'AS' },
  { label: 'Andorra', value: 'AD' },
  { label: 'Angola', value: 'AO' },
  { label: 'Antigua and Barbuda', value: 'AG' },
  { label: 'Argentina', value: 'AR' },
  { label: 'Armenia', value: 'AM' },
  { label: 'Australia', value: 'AU' },
  { label: 'Austria', value: 'AT' },
  { label: 'Azerbaijan ', value: 'AZ' },
  { label: 'Bahamas', value: 'BS' },
  { label: 'Bahrain', value: 'BH' },
  { label: 'Bangladesh', value: 'BD' },
  { label: 'Barbados', value: 'BB' },
  { label: 'Belgium', value: 'BE' },
  { label: 'Belize', value: 'BZ' },
  { label: 'Benin', value: 'BJ' },
  { label: 'Bhutan', value: 'BT' },
  { label: 'Bolivia', value: 'BO' },
  { label: 'Bosnia and Herzegovina', value: 'BA' },
  { label: 'Botswana', value: 'BW' },
  { label: 'Brazil', value: 'BR' },
  { label: 'Brunei', value: 'BN' },
  { label: 'Bulgaria', value: 'BG' },
  { label: 'Burkina Faso', value: 'BF' },
  { label: 'Burundi', value: 'BI' },
  { label: 'Cambodia', value: 'KH' },
  { label: 'Cameroon', value: 'CM' },
  { label: 'Cape Verde', value: 'CV' },
  { label: 'Central African Republic', value: 'CF' },
  { label: 'Chad', value: 'TD' },
  { label: 'Chile', value: 'CL' },
  { label: 'Christmas Island', value: 'CX' },
  { label: 'Cocos Islands', value: 'CC' },
  { label: 'Colombia', value: 'CO' },
  { label: 'Comoros', value: 'KM' },
  { label: 'Cook Islands', value: 'CK' },
  { label: 'Costa Rica', value: 'CR' },
  { label: "Cote d'Ivoire	", value: 'CI' },
  { label: 'Croatia', value: 'HR' },
  { label: 'Cyprus', value: 'CY' },
  { label: 'Czech Republic', value: 'CZ' },
  { label: 'Democratic Republic of the Congo', value: 'CD' },
  { label: 'Denmark', value: 'DK' },
  { label: 'Djibouti', value: 'DJ' },
  { label: 'Dominica', value: 'DM' },
  { label: 'Dominican Republic', value: 'DO' },
  { label: 'Ecuador', value: 'EC' },
  { label: 'Egypt', value: 'EG' },
  { label: 'El Salvador', value: 'SV' },
  { label: 'Equatorial Guinea', value: 'GQ' },
  { label: 'Eritrea', value: 'ER' },
  { label: 'Estonia', value: 'EE' },
  { label: 'Eswatini', value: 'SZ' },
  { label: 'Ethiopia', value: 'ET' },
  { label: 'Fiji', value: 'FJ' },
  { label: 'Finland', value: 'FI' },
  { label: 'France', value: 'FR' },
  { label: 'French Polynesia', value: 'PF' },
  { label: 'Gabon', value: 'GA' },
  { label: 'Gambia', value: 'GN' },
  { label: 'Georgia', value: 'GE' },
  { label: 'Germany', value: 'DE' },
  { label: 'Ghana', value: 'GH' },
  { label: 'Greece', value: 'GR' },
  { label: 'Grenada', value: 'GD' },
  { label: 'Guam', value: 'GU' },
  { label: 'Guatemala', value: 'GT' },
  { label: 'Guinea', value: 'GN' },
  { label: 'Guinea-Bissau', value: 'GW' },
  { label: 'Guyana', value: 'GY' },
  { label: 'Haiti', value: 'HT' },
  { label: 'Honduras', value: 'HN' },
  { label: 'Hong Kong', value: 'HK' },
  { label: 'Hungary', value: 'HU' },
  { label: 'Iceland', value: 'IS' },
  { label: 'India', value: 'IN' },
  { label: 'Indonesia', value: 'ID' },
  { label: 'Iraq', value: 'IQ' },
  { label: 'Ireland', value: 'IE' },
  { label: 'Israel ', value: 'IL' },
  { label: 'Italy', value: 'IT' },
  { label: 'Jamaica', value: 'JM' },
  { label: 'Jordan', value: 'JO' },
  { label: 'Kazakhstan', value: 'KZ' },
  { label: 'Kenya', value: 'KE' },
  { label: 'Kiribati', value: 'KI' },
  { label: 'Kuwait', value: 'KW' },
  { label: 'Kyrgyzstan', value: 'KG' },
  { label: 'Laos', value: 'LA' },
  { label: 'Latvia', value: 'LV' },
  { label: 'Lebanon', value: 'LB' },
  { label: 'Lesotho', value: 'LS' },
  { label: 'Liberia', value: 'LR' },
  { label: 'Liechtenstein', value: 'LI' },
  { label: 'Lithuania', value: 'LT' },
  { label: 'Luxembourg', value: 'LU' },
  { label: 'Macao', value: 'MO' },
  { label: 'Macedonia', value: 'MK' },
  { label: 'Madagascar', value: 'MG' },
  { label: 'Malawi', value: 'MW' },
  { label: 'Malaysia', value: 'MY' },
  { label: 'Maldives', value: 'MV' },
  { label: 'Mali', value: 'ML' },
  { label: 'Malta', value: 'MT' },
  { label: 'Marshall Islands', value: 'MH' },
  { label: 'Mauritania', value: 'MR' },
  { label: 'Mauritius', value: 'MU' },
  { label: 'Mayotte', value: 'YT' },
  { label: 'Mexico', value: 'MX' },
  { label: 'Micronesia', value: 'FM' },
  { label: 'Moldova', value: 'MD' },
  { label: 'Monaco', value: 'MC' },
  { label: 'Mongolia', value: 'MN' },
  { label: 'Montenegro', value: 'ME' },
  { label: 'Morocco', value: 'MA' },
  { label: 'Mozambique', value: 'MZ' },
  { label: 'Myanmar', value: 'MM' },
  { label: 'Namibia', value: 'NA' },
  { label: 'Nauru', value: 'NR' },
  { label: 'Nepal', value: 'NP' },
  { label: 'Netherlands', value: 'NL' },
  { label: 'New Caledonia', value: 'NC' },
  { label: 'New Zealand', value: 'NZ' },
  { label: 'Nicaragua', value: 'NI' },
  { label: 'Niger', value: 'NE' },
  { label: 'Nigeria', value: 'NG' },
  { label: 'Niue', value: 'NU' },
  { label: 'Norfolk Islands', value: 'NF' },
  { label: 'Northern Mariana Islands', value: 'MP' },
  { label: 'Norway', value: 'NO' },
  { label: 'Oman', value: 'OM' },
  { label: 'Pakistan', value: 'PK' },
  { label: 'Palau', value: 'PW' },
  { label: 'Palestinian Territory', value: 'PS' },
  { label: 'Panama', value: 'PA' },
  { label: 'Papua New Guinea', value: 'PG' },
  { label: 'Paraguay', value: 'PY' },
  { label: 'Peru', value: 'PE' },
  { label: 'Philippines', value: 'PH' },
  { label: 'Pitcairn Islands', value: 'PN' },
  { label: 'Poland', value: 'PL' },
  { label: 'Portugal', value: 'PT' },
  { label: 'Qatar', value: 'QA' },
  { label: 'Republic of the Congo', value: 'CD' },
  { label: 'Reunion', value: 'RE' },
  { label: 'Romania', value: 'RO' },
  { label: 'Rwanda', value: 'RW' },
  { label: 'Saint Helena, Ascension and Tristan da Cunha', value: 'SH' },
  { label: 'Saint Kitts and Nevis', value: 'KN' },
  { label: 'Saint Lucia', value: 'LC' },
  { label: 'Saint Vincent and the Grenadines', value: 'VC' },
  { label: 'Samoa', value: 'WS' },
  { label: 'San Marino', value: 'SM' },
  { label: 'Sao Tome and Principe', value: 'ST' },
  { label: 'Saudi Arabia', value: 'SA' },
  { label: 'Senegal', value: 'SN' },
  { label: 'Serbia', value: 'RS' },
  { label: 'Seychelles', value: 'SC' },
  { label: 'Sierra Leone', value: 'SL' },
  { label: 'Singapore', value: 'SG' },
  { label: 'Slovakia', value: 'SK' },
  { label: 'Slovenia', value: 'SI' },
  { label: 'Solomon Islands', value: 'SB' },
  { label: 'Solomon Islands', value: 'SB' },
  { label: 'Somalia', value: 'SO' },
  { label: 'South Africa', value: 'ZA' },
  { label: 'South Sudan', value: 'SS' },
  { label: 'Spain', value: 'ES' },
  { label: 'Sri Lanka', value: 'LK' },
  { label: 'Suriname', value: 'SR' },
  { label: 'Sweden', value: 'SE' },
  { label: 'Switzerland', value: 'CH' },
  { label: 'Taiwan', value: 'TW' },
  { label: 'Tajikistan', value: 'TJ' },
  { label: 'Tanzania', value: 'TZ' },
  { label: 'Thailand', value: 'TH' },
  { label: 'The Federated States of Micronesia', value: 'FM' },
  { label: 'Timor-Leste', value: 'TL' },
  { label: 'Togo', value: 'TG' },
  { label: 'Tokelau', value: 'TK' },
  { label: 'Tonga', value: 'TO' },
  { label: 'Trinidad and Tobago', value: 'TT' },
  { label: 'Tunisia', value: 'TN' },
  { label: 'Turkey', value: 'TR' },
  { label: 'Turkmenistan', value: 'TM' },
  { label: 'Tuvalu', value: 'TV' },
  { label: 'Uganda', value: 'UG' },
  { label: 'Ukraine', value: 'UA' },
  { label: 'United Arab Emirates', value: 'AE' },
  { label: 'Uruguay', value: 'UY' },
  { label: 'Uzbekistan', value: 'UZ' },
  { label: 'Vanuatu', value: 'VU' },
  { label: 'Venezuela', value: 'VE' },
  { label: 'Vietnam', value: 'VN' },
  { label: 'Wallis and Futuna', value: 'WF' },
  { label: 'Western Sahara', value: 'EH' },
  { label: 'Yemen', value: 'YE' },
  { label: 'Zambia', value: 'ZM' },
  { label: 'Zimbabwe', value: 'ZW' }
];

export const monthOptions = [
  { label: 'jan', value: '01' },
  { label: 'feb', value: '02' },
  { label: 'mar', value: '03' },
  { label: 'apr', value: '04' },
  { label: 'may', value: '05' },
  { label: 'jun', value: '06' },
  { label: 'jul', value: '07' },
  { label: 'aug', value: '08' },
  { label: 'sep', value: '09' },
  { label: 'oct', value: '10' },
  { label: 'nov', value: '11' },
  { label: 'dec', value: '12' }
];

export const yearOptions = [
  { label: 2021, value: 2021 },
  { label: 2020, value: 2020 },
  { label: 2019, value: 2019 },
  { label: 2018, value: 2018 },
  { label: 2017, value: 2017 },
  { label: 2016, value: 2016 },
  { label: 2015, value: 2015 },
  { label: 2014, value: 2014 },
  { label: 2013, value: 2013 },
  { label: 2012, value: 2012 },
  { label: 2011, value: 2011 },
  { label: 2010, value: 2010 },
  { label: 2009, value: 2009 },
  { label: 2008, value: 2008 },
  { label: 2007, value: 2007 },
  { label: 2006, value: 2006 },
  { label: 2005, value: 2005 },
  { label: 2004, value: 2004 },
  { label: 2003, value: 2003 },
  { label: 2002, value: 2002 },
  { label: 2001, value: 2001 },
  { label: 2000, value: 2000 },
  { label: 1999, value: 1999 },
  { label: 1998, value: 1998 },
  { label: 1997, value: 1997 },
  { label: 1996, value: 1996 },
  { label: 1995, value: 1995 },
  { label: 1994, value: 1994 },
  { label: 1993, value: 1993 },
  { label: 1992, value: 1992 },
  { label: 1991, value: 1991 },
  { label: 1990, value: 1990 },
  { label: 1989, value: 1989 },
  { label: 1988, value: 1988 },
  { label: 1987, value: 1987 },
  { label: 1986, value: 1986 },
  { label: 1985, value: 1985 },
  { label: 1984, value: 1984 },
  { label: 1983, value: 1983 },
  { label: 1982, value: 1982 },
  { label: 1981, value: 1981 },
  { label: 1980, value: 1980 },
  { label: 1979, value: 1979 },
  { label: 1978, value: 1978 },
  { label: 1977, value: 1977 },
  { label: 1976, value: 1976 },
  { label: 1975, value: 1975 },
  { label: 1974, value: 1974 },
  { label: 1973, value: 1973 },
  { label: 1972, value: 1972 },
  { label: 1971, value: 1971 },
  { label: 1970, value: 1970 },
  { label: 1969, value: 1969 },
  { label: 1968, value: 1968 },
  { label: 1967, value: 1967 },
  { label: 1966, value: 1966 },
  { label: 1965, value: 1965 },
  { label: 1964, value: 1964 },
  { label: 1963, value: 1963 },
  { label: 1962, value: 1962 },
  { label: 1961, value: 1961 },
  { label: 1960, value: 1960 },
  { label: 1959, value: 1959 },
  { label: 1958, value: 1958 },
  { label: 1957, value: 1957 },
  { label: 1956, value: 1956 },
  { label: 1955, value: 1955 },
  { label: 1954, value: 1954 },
  { label: 1953, value: 1953 },
  { label: 1952, value: 1952 },
  { label: 1951, value: 1951 },
  { label: 1950, value: 1950 },
  { label: 1949, value: 1949 },
  { label: 1948, value: 1948 },
  { label: 1947, value: 1947 },
  { label: 1946, value: 1946 },
  { label: 1945, value: 1945 },
  { label: 1944, value: 1944 },
  { label: 1943, value: 1943 },
  { label: 1942, value: 1942 },
  { label: 1941, value: 1941 },
  { label: 1940, value: 1940 },
  { label: 1939, value: 1939 },
  { label: 1938, value: 1938 },
  { label: 1937, value: 1937 },
  { label: 1936, value: 1936 },
  { label: 1935, value: 1935 },
  { label: 1934, value: 1934 },
  { label: 1933, value: 1933 },
  { label: 1932, value: 1932 },
  { label: 1931, value: 1931 },
  { label: 1930, value: 1930 },
  { label: 1929, value: 1929 },
  { label: 1928, value: 1928 },
  { label: 1927, value: 1927 },
  { label: 1926, value: 1926 },
  { label: 1925, value: 1925 },
  { label: 1924, value: 1924 },
  { label: 1923, value: 1923 },
  { label: 1922, value: 1922 },
  { label: 1921, value: 1921 },
  { label: 1920, value: 1920 },
  { label: 1919, value: 1919 },
  { label: 1918, value: 1918 },
  { label: 1917, value: 1917 },
  { label: 1916, value: 1916 },
  { label: 1915, value: 1915 },
  { label: 1914, value: 1914 },
  { label: 1913, value: 1913 },
  { label: 1912, value: 1912 },
  { label: 1911, value: 1911 },
  { label: 1910, value: 1910 },
  { label: 1909, value: 1909 },
  { label: 1908, value: 1908 },
  { label: 1907, value: 1907 },
  { label: 1906, value: 1906 },
  { label: 1905, value: 1905 }
];

export const dayOptions = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
  { label: 6, value: 6 },
  { label: 7, value: 7 },
  { label: 8, value: 8 },
  { label: 9, value: 9 },
  { label: 10, value: 10 },
  { label: 11, value: 11 },
  { label: 12, value: 12 },
  { label: 13, value: 13 },
  { label: 14, value: 14 },
  { label: 15, value: 15 },
  { label: 16, value: 16 },
  { label: 17, value: 17 },
  { label: 18, value: 18 },
  { label: 19, value: 19 },
  { label: 20, value: 20 },
  { label: 21, value: 21 },
  { label: 22, value: 22 },
  { label: 23, value: 23 },
  { label: 24, value: 24 },
  { label: 25, value: 25 },
  { label: 26, value: 26 },
  { label: 27, value: 27 },
  { label: 28, value: 28 },
  { label: 29, value: 29 },
  { label: 30, value: 30 },
  { label: 31, value: 31 }
];

export const trustedLogin = [
  {
    ip: '12.3.45**',
    date_time: 'DATE / TIME',
    loaction: 'Region / Country Code'
  },
  {
    ip: '12.3.45**',
    date_time: 'DATE / TIME',
    loaction: 'Region / Country Code'
  },
  {
    ip: '12.3.45**',
    date_time: 'DATE / TIME',
    loaction: 'Region / Country Code'
  }
];

export const NVIDIACards = [
  { label: 'GeForce RTX 4090 Laptop GPU', value: 'GeForce RTX 4090 Laptop GPU' },
  { label: 'GeForce RTX 4080 Laptop GPU', value: 'GeForce RTX 4080 Laptop GPU' },
  { label: 'GeForce RTX 4070 Laptop GPU', value: 'GeForce RTX 4070 Laptop GPU' },
  { label: 'GeForce RTX 4060 Laptop GPU', value: 'GeForce RTX 4060 Laptop GPU' },
  { label: 'GeForce RTX 4050 Laptop GPU', value: 'GeForce RTX 4050 Laptop GPU' },
  { label: 'GeForce RTX 4090', value: 'GeForce RTX 4090' },
  { label: 'GeForce RTX 4080', value: 'GeForce RTX 4080' },
  { label: 'GeForce RTX 4070 Ti', value: 'GeForce RTX 4070 Ti' },
  { label: 'GeForce RTX 4070', value: 'GeForce RTX 4070' },
  { label: 'GeForce RTX 4060 Ti', value: 'GeForce RTX 4060 Ti' },
  { label: 'GeForce RTX 4060', value: 'GeForce RTX 4060' },
  { label: 'GeForce RTX 3080 Ti Laptop GPU', value: 'GeForce RTX 3080 Ti Laptop GPU' },
  { label: 'GeForce RTX 3080 Laptop GPU', value: 'GeForce RTX 3080 Laptop GPU' },
  { label: 'GeForce RTX 3070 Ti Laptop GPU', value: 'GeForce RTX 3070 Ti Laptop GPU' },
  { label: 'GeForce RTX 3070 Laptop GPU', value: 'GeForce RTX 3070 Laptop GPU' },
  { label: 'GeForce RTX 3060 Laptop GPU', value: 'GeForce RTX 3060 Laptop GPU' },
  { label: 'GeForce RTX 3050 Ti Laptop GPU', value: 'GeForce RTX 3050 Ti Laptop GPU' },
  { label: 'GeForce RTX 3050 Laptop GPU', value: 'GeForce RTX 3050 Laptop GPU' },
  { label: 'GeForce RTX 3090 Ti', value: 'GeForce RTX 3090 Ti' },
  { label: 'GeForce RTX 3090', value: 'GeForce RTX 3090' },
  { label: 'GeForce RTX 3080 Ti', value: 'GeForce RTX 3080 Ti' },
  { label: 'GeForce RTX 3080', value: 'GeForce RTX 3080' },
  { label: 'GeForce RTX 3070 Ti', value: 'GeForce RTX 3070 Ti' },
  { label: 'GeForce RTX 3070', value: 'GeForce RTX 3070' },
  { label: 'GeForce RTX 3060 Ti', value: 'GeForce RTX 3060 Ti' },
  { label: 'GeForce RTX 3060', value: 'GeForce RTX 3060' },
  { label: 'GeForce RTX 3050', value: 'GeForce RTX 3050' },
  { label: 'GeForce RTX 2080 SUPER', value: 'GeForce RTX 2080 SUPER' },
  { label: 'GeForce RTX 2080', value: 'GeForce RTX 2080' },
  { label: 'GeForce RTX 2070 SUPER', value: 'GeForce RTX 2070 SUPER' },
  { label: 'GeForce RTX 2070', value: 'GeForce RTX 2070' },
  { label: 'GeForce RTX 2060 Ti', value: 'GeForce RTX 2060 Ti' },
  { label: 'GeForce RTX 2050', value: 'GeForce RTX 2050' },
  { label: 'GeForce RTX 2080 Ti', value: 'GeForce RTX 2080 Ti' },
  { label: 'GeForce RTX 2080 SUPER', value: 'GeForce RTX 2080 SUPER' },
  { label: 'GeForce RTX 2080', value: 'GeForce RTX 2080' },
  { label: 'GeForce RTX 2070 SUPER', value: 'GeForce RTX 2070 SUPER' },
  { label: 'GeForce RTX 2070', value: 'GeForce RTX 2070' },
  { label: 'GeForce RTX 2060 SUPER', value: 'GeForce RTX 2060 SUPER' },
  { label: 'GeForce RTX 2060', value: 'GeForce RTX 2060' },
  { label: 'GeForce GTX 1660 Ti', value: 'GeForce GTX 1660 Ti' },
  { label: 'GeForce GTX 1650 Ti', value: 'GeForce GTX 1650 Ti' },
  { label: 'GeForce GTX 1650', value: 'GeForce GTX 1650' },
  { label: 'GeForce GTX 1660 SUPER', value: 'GeForce GTX 1660 SUPER' },
  { label: 'GeForce GTX 1650 SUPER', value: 'GeForce GTX 1650 SUPER' },
  { label: 'GeForce GTX 1660 Ti', value: 'GeForce GTX 1660 Ti' },
  { label: 'GeForce GTX 1660', value: 'GeForce GTX 1660' },
  { label: 'GeForce GTX 1650', value: 'GeForce GTX 1650' },
  { label: 'GeForce GTX 1630', value: 'GeForce GTX 1630' },
  { label: 'GeForce GTX 1080', value: 'GeForce GTX 1080' },
  { label: 'GeForce GTX 1070', value: 'GeForce GTX 1070' },
  { label: 'GeForce GTX 1060', value: 'GeForce GTX 1060' },
  { label: 'GeForce GTX 1050 Ti', value: 'GeForce GTX 1050 Ti' },
  { label: 'GeForce GTX 1650', value: 'GeForce GTX 1650' },
  { label: 'GeForce GTX 1080 Ti', value: 'GeForce GTX 1080 Ti' },
  { label: 'GeForce GTX 1080', value: 'GeForce GTX 1080' },
  { label: 'GeForce GTX 1070 Ti', value: 'GeForce GTX 1070 Ti' },
  { label: 'GeForce GTX 1070', value: 'GeForce GTX 1070' },
  { label: 'GeForce GTX 1060', value: 'GeForce GTX 1060' },
  { label: 'GeForce GTX 1050 Ti', value: 'GeForce GTX 1050 Ti' },
  { label: 'GeForce GTX 1050', value: 'GeForce GTX 1050' },
  { label: 'GeForce GT 1030', value: 'GeForce GT 1030' },
  { label: 'GeForce GT 1010', value: 'GeForce GT 101' }
];

export const AMDCards = [
  { label: 'AMD Radeon RX 7900 XTX', value: 'AMD Radeon RX 7900 XTX' },
  { label: 'AMD Radeon RX 7900 XT', value: 'AMD Radeon RX 7900 XT' },
  { label: 'AMD Radeon RX 7600', value: 'AMD Radeon RX 7600' },
  { label: 'AMD Radeon RX 6950 XT', value: 'AMD Radeon RX 6950 XT' },
  { label: 'AMD Radeon RX 6900 XT', value: 'AMD Radeon RX 6900 XT' },
  { label: 'AMD Radeon RX 6800 XT', value: 'AMD Radeon RX 6800 XT' },
  { label: 'AMD Radeon RX 6800', value: 'AMD Radeon RX 6800' },
  { label: 'AMD Radeon RX 6750 XT', value: 'AMD Radeon RX 6750 XT' },
  { label: 'AMD Radeon RX 6700 XT', value: 'AMD Radeon RX 6700 XT' },
  { label: 'AMD Radeon RX 6700', value: 'AMD Radeon RX 6700' },
  { label: 'AMD Radeon RX 6650 XT', value: 'AMD Radeon RX 6650 XT' },
  { label: 'AMD Radeon RX 6600 XT', value: 'AMD Radeon RX 6600 XT' },
  { label: 'AMD Radeon RX 6600', value: 'AMD Radeon RX 6600' },
  { label: 'AMD Radeon RX 6650 XT', value: 'AMD Radeon RX 6650 XT' },
  { label: 'AMD Radeon RX 6400', value: 'AMD Radeon RX 6400' },
  { label: 'AMD Radeon RX 6800M', value: 'AMD Radeon RX 6800M' },
  { label: 'AMD Radeon RX 6700M', value: 'AMD Radeon RX 6700M' },
  { label: 'AMD Radeon RX 6600M', value: 'AMD Radeon RX 6600M' },
  { label: 'AMD Radeon RX 6550M', value: 'AMD Radeon RX 6550M' },
  { label: 'AMD Radeon RX 6500M', value: 'AMD Radeon RX 6500M' },
  { label: 'AMD Radeon RX 6450M', value: 'AMD Radeon RX 6450M' },
  { label: 'AMD Radeon RX 6300M', value: 'AMD Radeon RX 6300M' },
  { label: 'AMD Radeon 6800S', value: 'AMD Radeon 6800S' },
  { label: 'AMD Radeon RX 6700S', value: 'AMD Radeon RX 6700S' },
  {
    label: 'AMD Radeon RX 5700 XT 50th Anniversary',
    name: 'AMD Radeon RX 5700 XT 50th Anniversary'
  },
  { label: 'AMD Radeon RX 5700 XT', value: 'AMD Radeon RX 5700 XT' },
  { label: 'AMD Radeon RX 5700', value: 'AMD Radeon RX 5700' },
  { label: 'AMD Radeon RX 5600 XT', value: 'AMD Radeon RX 5600 XT' },
  { label: 'AMD Radeon RX 5500 XT', value: 'AMD Radeon RX 5500 XT' },
  { label: 'AMD Radeon RX 5500', value: 'AMD Radeon RX 5500' },
  { label: 'AMD Radeon RX 5300', value: 'AMD Radeon RX 5300' }
];
